import { yupPrefixedKeyStringSchema, zKey } from '@nucleus/ncu-key-prefix';
import * as yup from 'yup';
import { z } from 'zod';

export const CodeSnippetSchema = z.object({
  id: zKey.prefixedKey('codesnippet'),
  name: z.string().trim(),
  language: z.enum(['html', 'css', 'javascript']),
  location: z.string().optional(),
  content: z.string().trim().default(''),
  enabled: z.boolean().default(false),
});

export type CodeSnippet = z.infer<typeof CodeSnippetSchema>;

export const CodeSnippetWebKeys = ['id', 'language', 'location', 'content', 'enabled'] as const;
export type CodeSnippetWebKeys = (typeof CodeSnippetWebKeys)[number];

export type CodeSnippetWeb = Pick<CodeSnippet, CodeSnippetWebKeys>;

/** @deprecated Use CodeSnippetSchema instead */
export const CodeSnippetSchemaYup = yup.object().shape({
  id: yupPrefixedKeyStringSchema('codesnippet').required(),
  name: yup.string().trim().required(),
  language: yup
    .string()
    .trim()
    .oneOf(['css', 'html', 'javascript'] as const)
    .required(),
  location: yup.string(),
  content: yup.string().trim().default('').strict(true),
  enabled: yup.boolean().default(false).required(),
});
